import React, { useState, useEffect } from "react";
import logo from "./logo.svg";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { Box, Stack } from "@mui/material";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepButton from "@mui/material/StepButton";
import { useSelector, Provider } from "react-redux";
import store from "./Components/redux/store";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "./Components/ThemeProvider/ThemeProvider";
import Router from "./routes";
import BackToTopButton from "./Components/BacktoTop/BackToTopComp";
import FooterComp from "./Components/FooterComp/FooterComp";
import HeaderComp from "./Components/HeaderComp/HeaderComp";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <HeaderComp />

      <BrowserRouter>
        <Router />
      </BrowserRouter>

      <FooterComp />
      <BackToTopButton />
    </ThemeProvider>
  );
}

export default App;
